/* A la resposta tenim la view i l'identificador del partit */
function liga_elimina_puntuacion_callback(res) {
    //NV: 29/07/2019. Pendent optimització (l'acció d'eliminar un resultat no és habitual ...)
    //JP: 09/10/2019. Carreguem altre cop els partits de lliga, ja que hem modificat la localització i el sistema de mostrar les puntuacions
    if (res.error == 0) {
       if (parseInt($("#id_reg_campeonatos_tipo").val())==2){
           ligaConPartidos.vue.cargarPartidos();
       }else{
           window.location.reload();
       }
    }

    if (window.location.href.indexOf("cal_event.php") !== -1){
        window.location.reload(); //estem editant la puntuació des de dins d'una reserva. Cal fer un reload pq refresqui el resultat (des de campionats ja es repinti amb una altre codi i no s'ha de fer reload)
    }
    $("#modal_c").modal('hide');
    
}

function partido_edit_callback(res) {
    if (res.error == 0) {
        if (parseInt($("#id_reg_campeonatos_tipo").val())==2){
            ligaConPartidos.vue.cargarPartidos();
        }else{
            window.location.reload();
        }
        $("#modal_c").modal('hide');
    } else {
        $(".message").html(res.message);
    }
}
